var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('aside',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.title,style:({ color: _vm.color ?? '#5c6b66' })},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }